export default __webpack_public_path__ + "static/media/frontendicon.1c933b6e.svg";